import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6">
          <div className="max-w-2xl mx-auto bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700/50 rounded-xl p-5">
            <div className="font-display font-semibold text-red-800 dark:text-red-200 mb-2">
              Something went wrong rendering this page.
            </div>
            <div className="text-sm text-red-700 dark:text-red-300 font-mono break-words mb-3">
              {String(this.state.error?.message || this.state.error)}
            </div>
            <button
              onClick={() => this.setState({ error: null })}
              className="px-3 py-1.5 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}